// disabled most ts checks for the whole file as the feature is not used
// someone clean this up after ts migration please
import {
  useGetTinkConnections,
  useRetrieveTinkReports,
  useTinkIntegrationLink,
} from '@/services/integrations'
import { isEmpty } from 'ramda'
import { goToExternalUrl } from '../url'
import { BankingIntegrationConfig } from '@/pages/Profile/components'

interface ConnectionStatus {
  status: string
}

const anyConnectionPending = (connections: ConnectionStatus[] = []) =>
  connections.some((connection) => connection.status === 'pending')

const anyConnectionCompleted = (connections: ConnectionStatus[] = []) =>
  connections.some((connection) => connection.status === 'connected')

const defaultConfig: BankingIntegrationConfig = {
  source: 'profile-integrations',
}

export const useBankingIntegration = (
  config: BankingIntegrationConfig = defaultConfig,
  // TODO string is actually wrong, this needs to be a boolean
  shouldFetchIntegrations: string | boolean = true,
) => {
  const {
    data: connections,
    isLoading: isGetTinkConnectionsLoading,
  } = useGetTinkConnections()

  const {
    mutateAsync: tinkIntegrationLinkMutateAsync,
    isLoading: isTinkIntegrationLinkDataLoading,
  } = useTinkIntegrationLink(config)

  const redirectUserToTink = () => {
    // @ts-expect-error disabled
    tinkIntegrationLinkMutateAsync().then((response) => {
      // @ts-expect-error disabled
      if (response?.link) {
        // @ts-expect-error disabled
        goToExternalUrl(response.link)
      }
    })
  }

  const {
    data: tinkReportsData = {},
    isLoading: isTinkReportsDataLoading,
  } = useRetrieveTinkReports({
    enabled:
      Boolean(shouldFetchIntegrations) &&
      anyConnectionCompleted(connections?.connections),
  })

  return {
    redirectUserToTink,
    canGenerateTinkLink:
      anyConnectionPending(connections?.connections) ||
      isEmpty(connections?.connections),
    connections: connections?.connections,
    isLoading:
      isTinkIntegrationLinkDataLoading ||
      isTinkReportsDataLoading ||
      isGetTinkConnectionsLoading,
    reports: tinkReportsData,
  }
}
